__turbopack_context__.v({
  "bars": "music-module__m5Wgnq__bars",
  "disc": "music-module__m5Wgnq__disc",
  "ep-bar": "music-module__m5Wgnq__ep-bar",
  "ep-spin": "music-module__m5Wgnq__ep-spin",
});
